import { ComponentType, PropsWithChildren } from 'react';

import {
  DevHubCard,
  DevHubCardHeader,
  DevHubDivider,
  DevHubCardContent,
} from '@devxdiscover/devhub-ui';
import { Header, Page, Content } from '@backstage/core-components';
import { PluginErrorBoundary } from './PluginErrorBoundary';
import { PluginButton } from './PluginButton';

export enum PluginType {
  FULL_PAGE = 'full-page',
  CARD = 'card',
  TAB = 'tab',
}

interface DisplayComponentProps {
  type: PluginType;
  title?: string;
  subTitle?: string;
  modalContent: ComponentType<any>;
}

/**
 * Plugin Manager component
 * @param props Props passed to the component
 */
export function PluginManager(props: PropsWithChildren<DisplayComponentProps>) {
  const { children, type, title, subTitle, modalContent: ModalContent } = props;

  return (
    <>
      {type === PluginType.FULL_PAGE && (
        <Page themeId="home">
          <Header title={title} subtitle={subTitle}>
            <PluginButton modalContent={ModalContent} buttonColor="white" />
          </Header>
          <Content>
            <PluginErrorBoundary>{children}</PluginErrorBoundary>
          </Content>
        </Page>
      )}
      {type === PluginType.TAB && (
        <>
          <PluginButton modalContent={ModalContent} buttonColor="primary" />
          <PluginErrorBoundary>{children}</PluginErrorBoundary>
        </>
      )}
      {type === PluginType.CARD && (
        <DevHubCard>
          <DevHubCardHeader
            title={title}
            action={
              <PluginButton modalContent={ModalContent} buttonColor="primary" />
            }
          />
          <DevHubDivider />
          <DevHubCardContent>
            <PluginErrorBoundary>{children}</PluginErrorBoundary>
          </DevHubCardContent>
        </DevHubCard>
      )}
    </>
  );
}
